import { TransformBoolean } from '../../../shared/decorators/transform-boolean.decorator';
import { DiscountConfigurationMode } from '../../../shared/modules/vehicle-categories/enums/discount-configuration-mode.enum';

export class TenantSettingsDiscountsDto {
  @TransformBoolean()
  isStandardDiscountEnabled?: boolean;
  defaultDiscountConfigurationMode?: DiscountConfigurationMode;
}
